import { Component, ViewChild } from "@angular/core";
import { ModalComponent } from "../modal.component/modal.component";
import { TicketPackage } from "src/app/model/interfaces/ticket-package";
import { PriceService, PrizesService } from "../../../../services";
import { PrizesTable } from "src/app/services/prizes.service";
import { TrackingFacadeService } from "src/app/services/tracking/tracking-facade.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-draw-info-modal",
    templateUrl: "./draw-info-modal.component.html",
    styleUrls: ["./draw-info-modal.component.scss"],
})
export class DrawInfoModalComponent {
    @ViewChild("modal") public modal: ModalComponent;

    public router: Router;

    public constructor(router: Router
    ) { 
        this.router = router;
    }

    public ngOnInit() {
    }

    public navigateToLP() {
        this.router.navigateByUrl("/15");
    }

    public open() {
        this.modal.open();
    }

    public closeModal() {
        this.modal.close();
    }
}
